export const ADMIN_CONSOLE_ADMIN_TOOLS_IMPLEMENTATION_GUIDE =
  "adminConsoleAdminToolsImplementationGuide";

export const BASE_URL = "/admin/implementation-guide";
